import { FieldState } from "formstate";
import React from "react";
import { AutoComplete } from "@fidget/common/components/form/autoComplete/autoComplete";
import { intl } from "@fidget/common/i18n/TypedIntl";
import { mapStrategyToString } from "@fidget/common/utils/urlMappingHelpers";
import styles from "../../taggingSettings.css";
import { MatchingStrategy } from "@closerplatform/spinner-openapi";
interface Props {
  field: FieldState<string>;
  initiallyOpen?: boolean;
}
export const StrategyPicker = ({ field: matchingStrategy, initiallyOpen = false }: Props) => {
  return (
    <AutoComplete<MatchingStrategy>
      className={styles["form-drop-down"]}
      onChange={(value) => matchingStrategy.onChange(value)}
      itemsProvider={() => Object.values(MatchingStrategy)}
      itemToString={mapStrategyToString}
      readOnly
      initialIsOpen={initiallyOpen}
      inputValue={
        matchingStrategy.value
          ? mapStrategyToString(matchingStrategy.value)
          : intl.formatMessage("settings.tagging.addNewTagging")
      }
    />
  );
};
